import React from "react";
import { useTranslation } from "react-i18next";

export const Certification = () => {
  const {t} = useTranslation();

  const [certificationData, setCertificationData] = React.useState({
    title: "",
    imageUrl: "",
    show: false
  });
  return(
    <>
      <div className="contentBox" style={{padding: "100px 0 120px 0"}}>
        <div>
          <h3>{t("certification_01")}</h3>

          <ul>
            <li>
              <button onClick={() => setCertificationData({title: t("certification_02"), imageUrl: '/assets/images/BSI_ISO14001_detail.png', show: true})}>
                <p>{t("certification_02")}</p>
                <img src="/assets/images/BSI_ISO14001.jpg" alt="BSI_ISO14001"/>
              </button>
            </li>
            <li>
              <button onClick={() => setCertificationData({title: t("certification_03"), imageUrl: '/assets/images/BSI_ISO45001_detail.png', show: true})}>
                <p>{t("certification_03")}</p>
                <img src="/assets/images/BSI_ISO45001.jpg" alt="BSI_ISO45001"/>
              </button>
            </li>
          </ul>
          {certificationData?.show && (
            <section>

              <div className="mainPopUp3">
                <div>
                  <div>
                    <h3>{certificationData?.title}</h3>
                  </div>
                  <div>
                    <img src={certificationData?.imageUrl} alt={certificationData?.title}/>
                  </div>
                </div>
                <div className="btnBox">
                  <div></div>
                  <button onClick={() => setCertificationData({title: '', imageUrl: '', show: false})}>닫기</button>
                </div>
              </div>
            </section>
          )}

        </div>
      </div>
    </>
  )
}
